import React from 'react';


const LOCAL_ICON_MAP = {
  grid: '/assets/icons/Grid.png',
  remxas: '/assets/icons/RemxasIcon.png',
  filter: '/assets/icons/Filter.png',
  logoRex: '/assets/icons/logoRex.png',
  notFound: '/assets/images/EmptyStates/NotFound.png',
  accessDenied: '/assets/images/EmptyStates/AccessDenied.png',
  emptyList: '/assets/images/EmptyStates/EmptyList.png',
} as const;

const ALT_MAP: Record<keyof typeof LOCAL_ICON_MAP, string> = {
  grid: 'Grid',
  remxas: 'Remxas',
  filter: 'Filter',
  logoRex: 'Rex+',
  notFound: 'Not found',
  accessDenied: 'Access denied',
  emptyList: 'Empty list',
};

export type LocalIconName = keyof typeof LOCAL_ICON_MAP;

export interface LocalIconProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  name: LocalIconName;
  className?: string;
  alt?: string;
}

export const LocalIcon: React.FC<LocalIconProps> = ({
  name,
  className = 'w-6 h-6',
  alt,
  ...imgProps
}) => {
  const src = LOCAL_ICON_MAP[name];
  return (
    <img
      src={src}
      alt={alt ?? ALT_MAP[name]}
      className={className}
      loading="lazy"
      draggable={false}
      {...imgProps}
    />
  );
};